<app-header></app-header>
<section class="notd__grid stream-wrapper wrapper--centered wrapper--organized">
  <alert-message [alert]="alert"></alert-message>
  <h2 class="stream-details__title">
    <span class="stream-details__title__stats-holder">
      <label class="stream-details__title__stats-holder__label">{{stream.name}}</label>
      <span class="stream-details__title__stats-holder__subscribers">{{stream.numSubs | number : '1.0'}} Subscribers</span>
    </span>
    <div class="stream-details__title__actions">
      <span 
        class="label-info type--alert"
        *ngIf="isLoggedIn && isEditable && stream.trashed"
        placement="top"
        ngbTooltip="This stream is already deleted. You can either remove it entirely or restore it.">
        <fa-icon [icon]="['fas', 'info-circle']"></fa-icon>
        Deleted
      </span>
      <span class="stream-details__title__actions__follow-wrapper">
        <!-- <label>{{ stream.followers }} Followers</label> -->
        <button
          (click)="isMobile ? showFollowingModal() : followStream()"
          *ngIf="isLoggedIn && userIsFollowing === FollowStatus.notfollowing" 
          placement="bottom"
          ngbTooltip="Get notifications of new notes on this stream"
          class="stream-details__title__actions__follow-wrapper__bell-icon">
            <svg class="stream-details__title__actions__follow-wrapper__bell-icon__bell" enable-background="new 0 0 509.369 509.369" height="512" viewBox="0 0 509.369 509.369" width="512" xmlns="http://www.w3.org/2000/svg"><g><path d="m432.393 333.194c-7.282 0-13.207-5.925-13.207-13.208v-93.298c0-73.66-48.665-136.166-115.532-157.059 2.01-5.598 3.072-11.541 3.072-17.588 0-28.695-23.345-52.041-52.042-52.041s-52.042 23.346-52.042 52.042c0 6.094 1.041 12.028 3.038 17.599-66.849 20.903-115.498 83.4-115.498 157.048v93.298c0 7.283-5.925 13.208-13.207 13.208-29.123 0-52.815 23.693-52.815 52.815s23.692 52.815 52.815 52.815h123.208c-1.19 4.591-1.813 9.362-1.813 14.231 0 31.052 25.263 56.314 56.314 56.314s56.314-25.262 56.314-56.314c0-4.868-.623-9.639-1.814-14.231h123.208c29.123 0 52.815-23.693 52.815-52.815.002-29.123-23.691-52.816-52.814-52.816zm-199.751-281.152c0-12.154 9.888-22.042 22.042-22.042s22.042 9.888 22.042 22.042c0 3.985-1.078 7.864-3.083 11.244-6.223-.717-12.547-1.099-18.959-1.099-6.405 0-12.722.381-18.939 1.097-2.008-3.37-3.103-7.218-3.103-11.242zm48.357 401.013c0 14.51-11.805 26.314-26.314 26.314s-26.314-11.804-26.314-26.314c0-5.126 1.462-10.025 4.177-14.231h44.273c2.716 4.206 4.178 9.105 4.178 14.231zm151.394-44.231h-355.418c-12.58 0-22.815-10.235-22.815-22.815s10.235-22.815 22.815-22.815c23.824 0 43.207-19.383 43.207-43.208v-93.298c0-74.165 60.337-134.502 134.502-134.502s134.502 60.337 134.502 134.502v93.298c0 23.825 19.383 43.208 43.207 43.208 12.58 0 22.815 10.235 22.815 22.815.001 12.58-10.235 22.815-22.815 22.815z"/></g></svg>
        </button>
        <button
          (click)="isMobile ? showFollowingModal() : unFollowStream()"
          *ngIf="isLoggedIn && userIsFollowing === FollowStatus.following"
          placement="bottom"
          ngbTooltip="Stop getting notifications"
          class="stream-details__title__actions__follow-wrapper__bell-icon">
            <svg class="stream-details__title__actions__follow-wrapper__bell-icon__bell" enable-background="new 0 0 509.369 509.369" height="512" viewBox="0 0 509.369 509.369" width="512" xmlns="http://www.w3.org/2000/svg"><g><path d="m432.393 333.194c-7.282 0-13.207-5.925-13.207-13.208v-93.298c0-73.66-48.665-136.166-115.532-157.059 2.01-5.598 3.072-11.541 3.072-17.588 0-28.695-23.345-52.041-52.042-52.041s-52.042 23.346-52.042 52.042c0 6.094 1.041 12.028 3.038 17.599-66.849 20.903-115.498 83.4-115.498 157.048v93.298c0 7.283-5.925 13.208-13.207 13.208-29.123 0-52.815 23.693-52.815 52.815s23.692 52.815 52.815 52.815h123.208c-1.19 4.591-1.813 9.362-1.813 14.231 0 31.052 25.263 56.314 56.314 56.314s56.314-25.262 56.314-56.314c0-4.868-.623-9.639-1.814-14.231h123.208c29.123 0 52.815-23.693 52.815-52.815.002-29.123-23.691-52.816-52.814-52.816zm-199.751-281.152c0-12.154 9.888-22.042 22.042-22.042s22.042 9.888 22.042 22.042c0 3.985-1.078 7.864-3.083 11.244-6.223-.717-12.547-1.099-18.959-1.099-6.405 0-12.722.381-18.939 1.097-2.008-3.37-3.103-7.218-3.103-11.242zm48.357 401.013c0 14.51-11.805 26.314-26.314 26.314s-26.314-11.804-26.314-26.314c0-5.126 1.462-10.025 4.177-14.231h44.273c2.716 4.206 4.178 9.105 4.178 14.231zm151.394-44.231h-355.418c-12.58 0-22.815-10.235-22.815-22.815s10.235-22.815 22.815-22.815c23.824 0 43.207-19.383 43.207-43.208v-93.298c0-74.165 60.337-134.502 134.502-134.502s134.502 60.337 134.502 134.502v93.298c0 23.825 19.383 43.208 43.207 43.208 12.58 0 22.815 10.235 22.815 22.815.001 12.58-10.235 22.815-22.815 22.815z"/></g></svg>
            <svg class="stream-details__title__actions__follow-wrapper__bell-icon__checked" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
              viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
              <g>
                <g>
                  <path d="M497.36,69.995c-7.532-7.545-19.753-7.558-27.285-0.032L238.582,300.845l-83.522-90.713
                    c-7.217-7.834-19.419-8.342-27.266-1.126c-7.841,7.217-8.343,19.425-1.126,27.266l97.126,105.481
                    c3.557,3.866,8.535,6.111,13.784,6.22c0.141,0.006,0.277,0.006,0.412,0.006c5.101,0,10.008-2.026,13.623-5.628L497.322,97.286
                    C504.873,89.761,504.886,77.54,497.36,69.995z"/>
                </g>
              </g>
              <g>
                <g>
                  <path d="M492.703,236.703c-10.658,0-19.296,8.638-19.296,19.297c0,119.883-97.524,217.407-217.407,217.407
                    c-119.876,0-217.407-97.524-217.407-217.407c0-119.876,97.531-217.407,217.407-217.407c10.658,0,19.297-8.638,19.297-19.296
                    C275.297,8.638,266.658,0,256,0C114.84,0,0,114.84,0,256c0,141.154,114.84,256,256,256c141.154,0,256-114.846,256-256
                    C512,245.342,503.362,236.703,492.703,236.703z"/>
                </g>
              </g>
            </svg>
        </button>
        <!-- <button
          *ngIf="isLoggedIn && userIsFollowing === FollowStatus.notfollowing"  
          (click)="followStream()" [title]="'Follow ' + stream.name + ' stream!'">Follow</button>
        <button
          class="button--followed"
          *ngIf="isLoggedIn && userIsFollowing === FollowStatus.following"  
          (click)="unFollowStream()"
          [title]="'Unfollow ' + stream.name + ' stream!'"></button> -->
      </span>
      <button 
        class="share--button"
        (click)="openSocialModal()" 
        title="Share link with your frieds."> 
        <svg height="512pt" viewBox="-21 0 512 512" width="512pt" xmlns="http://www.w3.org/2000/svg"><path d="m453.332031 85.332031c0 38.292969-31.039062 69.335938-69.332031 69.335938s-69.332031-31.042969-69.332031-69.335938c0-38.289062 31.039062-69.332031 69.332031-69.332031s69.332031 31.042969 69.332031 69.332031zm0 0"/><path d="m384 170.667969c-47.0625 0-85.332031-38.273438-85.332031-85.335938 0-47.058593 38.269531-85.332031 85.332031-85.332031s85.332031 38.273438 85.332031 85.332031c0 47.0625-38.269531 85.335938-85.332031 85.335938zm0-138.667969c-29.417969 0-53.332031 23.9375-53.332031 53.332031 0 29.398438 23.914062 53.335938 53.332031 53.335938s53.332031-23.9375 53.332031-53.335938c0-29.394531-23.914062-53.332031-53.332031-53.332031zm0 0"/><path d="m453.332031 426.667969c0 38.289062-31.039062 69.332031-69.332031 69.332031s-69.332031-31.042969-69.332031-69.332031c0-38.292969 31.039062-69.335938 69.332031-69.335938s69.332031 31.042969 69.332031 69.335938zm0 0"/><path d="m384 512c-47.0625 0-85.332031-38.273438-85.332031-85.332031 0-47.0625 38.269531-85.335938 85.332031-85.335938s85.332031 38.273438 85.332031 85.335938c0 47.058593-38.269531 85.332031-85.332031 85.332031zm0-138.667969c-29.417969 0-53.332031 23.9375-53.332031 53.335938 0 29.394531 23.914062 53.332031 53.332031 53.332031s53.332031-23.9375 53.332031-53.332031c0-29.398438-23.914062-53.335938-53.332031-53.335938zm0 0"/><path d="m154.667969 256c0 38.292969-31.042969 69.332031-69.335938 69.332031-38.289062 0-69.332031-31.039062-69.332031-69.332031s31.042969-69.332031 69.332031-69.332031c38.292969 0 69.335938 31.039062 69.335938 69.332031zm0 0"/><path d="m85.332031 341.332031c-47.058593 0-85.332031-38.269531-85.332031-85.332031s38.273438-85.332031 85.332031-85.332031c47.0625 0 85.335938 38.269531 85.335938 85.332031s-38.273438 85.332031-85.335938 85.332031zm0-138.664062c-29.417969 0-53.332031 23.933593-53.332031 53.332031s23.914062 53.332031 53.332031 53.332031c29.421875 0 53.335938-23.933593 53.335938-53.332031s-23.914063-53.332031-53.335938-53.332031zm0 0"/><path d="m135.703125 245.761719c-7.425781 0-14.636719-3.863281-18.5625-10.773438-5.824219-10.21875-2.238281-23.253906 7.980469-29.101562l197.949218-112.851563c10.21875-5.867187 23.253907-2.28125 29.101563 7.976563 5.824219 10.21875 2.238281 23.253906-7.980469 29.101562l-197.953125 112.851563c-3.328125 1.898437-6.953125 2.796875-10.535156 2.796875zm0 0"/><path d="m333.632812 421.761719c-3.585937 0-7.210937-.898438-10.539062-2.796875l-197.953125-112.851563c-10.21875-5.824219-13.800781-18.859375-7.976563-29.101562 5.800782-10.238281 18.855469-13.84375 29.097657-7.976563l197.953125 112.851563c10.21875 5.824219 13.800781 18.859375 7.976562 29.101562-3.945312 6.910157-11.15625 10.773438-18.558594 10.773438zm0 0"/></svg>
        Share
        <social-sharing [stream]="stream"></social-sharing>
      </button>
      <podcast
        *ngIf="showPodcastIcon"
        [streamId]="stream?.id"
        [showPodcastIcon]="showPodcastIcon"></podcast>
    </div>
  </h2>
  <section class="stream-details">
    <div class="stream-details__thumb-desc">
      <img-lazy-loading
        class="stream-details__thumbnail"
        *ngIf="stream && stream.iconImageUrl && stream.iconImageThbs"
        [mainThumb]="stream.iconImageUrl"
        [customSizes]="'(min-width: 601px) 30vw, (max-width: 600px) 80vw, 90vw'"
        [thumbs]="stream.iconImageThbs"
        [title]="'Read more about ' + stream.name"></img-lazy-loading>
      <a
        class="stream-details__add-thumb-wrapper"
        *ngIf="stream && stream.userId === user.id && !stream.iconImage"
        (click)="showThumbModal()">
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M19,13a1,1,0,0,0-1,1v.38L16.52,12.9a2.79,2.79,0,0,0-3.93,0l-.7.7L9.41,11.12a2.85,2.85,0,0,0-3.93,0L4,12.6V7A1,1,0,0,1,5,6h7a1,1,0,0,0,0-2H5A3,3,0,0,0,2,7V19a3,3,0,0,0,3,3H17a3,3,0,0,0,3-3V14A1,1,0,0,0,19,13ZM5,20a1,1,0,0,1-1-1V15.43l2.9-2.9a.79.79,0,0,1,1.09,0l3.17,3.17,0,0L15.46,20Zm13-1a.89.89,0,0,1-.18.53L13.31,15l.7-.7a.77.77,0,0,1,1.1,0L18,17.21ZM22.71,4.29l-3-3a1,1,0,0,0-.33-.21,1,1,0,0,0-.76,0,1,1,0,0,0-.33.21l-3,3a1,1,0,0,0,1.42,1.42L18,4.41V10a1,1,0,0,0,2,0V4.41l1.29,1.3a1,1,0,0,0,1.42,0A1,1,0,0,0,22.71,4.29Z" fill="#6563ff"/></svg>
        <span class="stream-details__add-thumb-wrapper__title">Click here to upload your stream thumbnail</span>
      </a>
      <image-editor
        *ngIf="stream && stream.userId === user.id && !stream.iconImage"
        (uploaded)="setStreamThumbnail($event)"
        [onlyModal]="true">
      </image-editor>
      <div class="stream-details__description">
        {{ streamDescriptionLimited || stream.description }}
      </div>
    </div>
    <div class="stream-details__stream-options">
      <aside class="stream-details__stream-options__author-info" *ngIf="owner">
        <img-lazy-loading
          class="stream-details__stream-options__author-info__avatar"
          *ngIf="owner && owner.profileImageUrl"
          [mainThumb]="owner.profileImageUrl"
          [title]="'Visit ' + (owner.displayName || owner.userNameDisp) + ' profile!'"
          [url]="['/user', owner.userName || stream.userId, 'profile']"
          [thumbs]="owner.profileImgThbs"></img-lazy-loading>
        <div class="stream-details__stream-options__author-info__details">
          <span class="stream-details__stream-options__author-info__details__label">Author</span>
          <a 
            *ngIf="owner && (owner.displayName || owner.userNameDisp)"
            class="stream-details__stream-options__author-info__details__name"
            [title]="'Visit ' + (owner.displayName || owner.userNameDisp) + ' profile!'"
            [routerLink]="['/user', owner.userName || stream.userId, 'profile']">{{ owner.displayName || owner.userNameDisp }}</a>
        </div>  
      </aside>
      <div class="stream-details__stream-options__actions">
        <button
          (click)="closeStreamEdition()"
          class="notd__button--v2 bg--transparent border--green"
          title="Close subcriptions details"
          *ngIf="plansAreVisible">
          Close subscription details
        </button>
        <button
          *ngIf="
            (subscriptionsStatus && !isStreamOwner && !isStreamFree && !isUserAdmin && !subscriptionsStatus.expiresDate &&
            ((stream.kind !== StreamKind.OpenCommunity) || (stream.kind === StreamKind.OpenCommunity && iamAlreadyACommunityMember))) || (isLoggedIn && isStreamFree && userIsFollowing !== FollowStatus.following)"
          class="subscribe--button"
          (click)="isStreamFree ? makeFakeFreeStreamSubscription() : openSubscribePlansModal()"
          [title]="'Subscribe to the ' + stream.name">{{isStreamFree ? 'Subscribe for free' : 'Subscribe'}}</button>
        <button
          *ngIf="stream.kind === StreamKind.OpenCommunity && !iamAlreadyACommunityMember && !isStreamOwner && !isUserAdmin"
          class="subscribe--button"
          (click)="isLoggedIn ? joinOpenCommunity() : signin()">
            {{isLoggedIn ? 'Join community to subscribe' : 'Login or sign-in to Join community to subscribe'}}
          </button>
        <button
          *ngIf="isEditable && !editingStream"
          (click)="openStreamModal()"
          class="notd__button--v2 bg--transparent border--green notd__m-r-10"
          [title]="'Edit stream'">Edit</button>
        <button
          *ngIf="isEditable && !editingStream && !stream.trashed"
          (click)="deleteStream()"
          class="notd__button--v2 bg--transparent border--green notd__m-r-10"
          [title]="'Delete stream'">Delete</button>
        <button
          *ngIf="isEditable && !editingStream && stream.trashed"
          [routerLink]="['/user', 'trash']"
          class="notd__button--v2 bg--transparent border--green notd__m-r-10"
          [title]="'Delete stream'">Remove & Restore</button>
        <button
          *ngIf="isEditable && !editingStream"
          (click)="showStreamStatsModal()"
          class="notd__button--v2 bg--transparent border--green notd__m-r-10 button--icon button--green"
          [title]="'Check list of blocked users'">
            <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><g data-name="1" id="_1"><path d="M230,455.73A176,176,0,0,1,54.13,279.86C54.14,182.89,133,104,230,104a15,15,0,0,1,15,15V264.86H390.87a15,15,0,0,1,15,15C405.87,376.83,327,455.73,230,455.73Zm-15-321c-73.41,7.53-130.86,69.73-130.87,145.1A146,146,0,0,0,230,425.73c75.37,0,137.57-57.45,145.1-130.87H230a15,15,0,0,1-15-15Z"/><path d="M441.13,248.63H276.23a15,15,0,0,1-15-15V68.73a15,15,0,0,1,15-15c99.2,0,179.9,80.71,179.9,179.9A15,15,0,0,1,441.13,248.63Zm-149.9-30H425.39A150.16,150.16,0,0,0,291.23,84.48Z"/></g></svg>
            Show stats
          </button>
        <button
          *ngIf="isEditable && !editingStream && (blockedUsersList && blockedUsersList.blockedUsers.length)"
          (click)="showBlockedUsersListModal()"
          class="notd__button--v2 bg--transparent border--green notd__m-r-10 button--icon button--green"
          [title]="'Check list of blocked users'">
            <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><defs><style>.cls-1{fill:#101820;}</style></defs><g data-name="Layer 27" id="Layer_27"><path class="cls-1" d="M14,25.18a5,5,0,0,1-5-5V18.36a1,1,0,0,1,.49-.86l3.63-2.18a1,1,0,0,1,1,1.72L11,18.93v1.25a3,3,0,0,0,3,3,1,1,0,0,1,0,2Z"/><path class="cls-1" d="M7,25.18H6a5,5,0,0,1-5-5V18.36a1,1,0,0,1,.49-.86l3.63-2.18a1,1,0,0,1,1,1.72L3,18.93v1.25a3,3,0,0,0,3,3H7a1,1,0,0,1,0,2Z"/><path class="cls-1" d="M10,15A6,6,0,0,1,10,3a1,1,0,0,1,0,2,4,4,0,0,0,0,8,1,1,0,0,1,0,2Z"/><path class="cls-1" d="M18,15a6,6,0,1,1,6-6A6,6,0,0,1,18,15ZM18,5a4,4,0,1,0,4,4A4,4,0,0,0,18,5Z"/><path class="cls-1" d="M24,29a7,7,0,1,1,7-7A7,7,0,0,1,24,29Zm0-12a5,5,0,1,0,5,5A5,5,0,0,0,24,17Z"/><path class="cls-1" d="M19.76,27.24a1,1,0,0,1-.71-.29,1,1,0,0,1,0-1.41l8.49-8.49A1,1,0,0,1,29,18.46L20.46,27A1,1,0,0,1,19.76,27.24Z"/></g></svg>
            Blocked users
          </button>
        <button
          *ngIf="isEditable && !editingStream && (stream.kind === StreamKind.OpenCommunity || stream.kind === StreamKind.InviteOnlyCommunity || stream.kind === StreamKind.PrivateCommunity || stream.kind === StreamKind.InviteOnly)"
          (click)="showStreamMembersModal()"
          class="notd__button--v2 bg--transparent border--green notd__m-r-10 button--icon button--green"
          [title]="'Check list of blocked users'">
            <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><defs><style>.cls-1{fill:#101820;}</style></defs><g data-name="Layer 20" id="Layer_20"><path class="cls-1" d="M16,22a6,6,0,1,1,6-6A6,6,0,0,1,16,22Zm0-10a4,4,0,1,0,4,4A4,4,0,0,0,16,12Z"/><path class="cls-1" d="M21,31H11a4,4,0,0,1-4-4V24.45a1,1,0,0,1,.63-.92l3.64-1.46A1,1,0,1,1,12,23.93l-3,1.2V27a2,2,0,0,0,2,2H21a2,2,0,0,0,2-2V25.13l-3-1.2a1,1,0,0,1,.74-1.86l3.64,1.46a1,1,0,0,1,.63.92V27A4,4,0,0,1,21,31Z"/><path class="cls-1" d="M9,11a5,5,0,1,1,5-5A5,5,0,0,1,9,11ZM9,3a3,3,0,1,0,3,3A3,3,0,0,0,9,3Z"/><path class="cls-1" d="M8,19.39H5a4,4,0,0,1-4-4V13.64a1,1,0,0,1,.63-.93l3.19-1.25A1,1,0,0,1,6.11,12a1,1,0,0,1-.56,1.3L3,14.32v1.07a2,2,0,0,0,2,2H8a1,1,0,0,1,0,2Z"/><path class="cls-1" d="M23,11a5,5,0,1,1,5-5A5,5,0,0,1,23,11Zm0-8a3,3,0,1,0,3,3A3,3,0,0,0,23,3Z"/><path class="cls-1" d="M27,19.39H24a1,1,0,0,1,0-2h3a2,2,0,0,0,2-2V14.32l-2.55-1a1,1,0,0,1-.56-1.3,1,1,0,0,1,1.29-.57l3.19,1.25a1,1,0,0,1,.63.93v1.75A4,4,0,0,1,27,19.39Z"/></g></svg>
            Members</button>
      </div>
    </div>   
    <div
      class="stream-details__other__loader subscriptions-loader"
      *ngIf="isLoggedIn && stream && !subscriptionsStatus && !isStreamOwner && stream.kind !== StreamKind.OpenCommunity">
      <fa-icon [icon]="['fas', 'sync']" [spin]="true" [size]="'xs'"></fa-icon>
      Loading stream subscriptions...
    </div> 
    <div
      class="stream-details__other"
      *ngIf="stream && !isStreamOwner">
      <div class="login-or-subscribe-info" *ngIf="!isLoggedIn">
        <h5>Want to read more?</h5>
        <div>
          <button (click)="loginScreenLoader = true"
                [ngClass]="{'button-spinner' : loginScreenLoader, 'min-price-label': !isLoggedIn && subscriptionPlansPrice && subscriptionPlansPrice['min']}"
                transact-auth
                [partnersModal]="notdPartnersModal"
                class="signup-or-login-button">
                  Login or sign-up to subscribe
                  <span *ngIf="!isLoggedIn && subscriptionPlansPrice && subscriptionPlansPrice['min']"
                        class="subs-min-price">from {{subscriptionPlansPrice['min'] / 100 | currency:'USD':'symbol':'1.2-2'}}{{notUSCitizen ? ' and free for new users' : ''}}</span>
          </button>
        </div>
        <notd-partners-modal
          #notdPartnersModal
          [buttonLabel]="'Login or sign-up to subscribe'"
          (modalClosed)="partnersModalClosed()"></notd-partners-modal>
      </div>
      <ng-container
        *ngIf="
          isLoggedIn && stream && subscriptionsStatus && !subscriptionsStatus.required">
        <div (click)="openSubscribePlansModal()" class="exp-subscription-messages">
          <div class="message">
            Your Subscription {{subscriptionsStatus.expired ? 'expired' : 'expires'}} on {{subscriptionsStatus.expiresDate | date: 'MMM dd, yyyy'}}. Click here if you want to extend the subscription.
          </div>
        </div>
      </ng-container>
      <button *ngIf="!isEditable && stream && plansAreVisible"
                    (click)="openSubscriptions(false)"
                    class="notd__button--v2 close-sub-button">Close subscription plans</button>
    </div>
  </section>
  <section class="stream-notes-wrapper">
    <div class="stream-notes-wrapper__loading-notes" *ngIf="loadingNotes">
      <fa-icon [icon]="['fas', 'sync']" [spin]="true"></fa-icon>
      Loading stream notes...
    </div>

    <note
      [hidden]="loadingNotes"
      *ngFor="let note of notes"
      [note]="note"
      [view]="'list'"
      [editNoteAllowed]="isUserTeamMember || isUserAdmin"
      (noteDeletedEmitter)="noteDeletedEvent($event)"></note>
  </section>
  <section
    class="stream-wrapper__show-more"
    *ngIf="!loadingNotes && notes && notes.length && notes.length < totalNumberNotes">
    <button
      (click)="showMoreNotes($event)"
      [ngClass]="{'loading--more': loadingShowMore}"
      class="notd__button--v2 border--green">{{ loadingShowMore ? 'Loading more...' : 'Show More' }}</button>
  </section>
</section>
<app-footer></app-footer>

<subscribe-plans
  *ngIf="!isStreamOwner && (stream.kind !== StreamKind.OpenCommunity) || (stream.kind === StreamKind.OpenCommunity && iamAlreadyACommunityMember)"
  [isLoggedIn]="isLoggedIn"
  [isStreamFree]="isStreamFree"
  [checkSubStatus]="true"
  (subscriptionsStatus)="subscriptionPlansStatus($event)"
  [streamId]="stream.id"></subscribe-plans>

<ng-template #followingModal class="following-modal" let-c="close" let-d="dismiss">
  <a (click)="d('Cross click')" data-cy="close-modal" class="following-modal__close-btn" title="Close Subscripton Plans Modal">
      <svg id="Capa_1" enable-background="new 0 0 413.348 413.348" height="512" viewBox="0 0 413.348 413.348" width="512" xmlns="http://www.w3.org/2000/svg"><path d="m413.348 24.354-24.354-24.354-182.32 182.32-182.32-182.32-24.354 24.354 182.32 182.32-182.32 182.32 24.354 24.354 182.32-182.32 182.32 182.32 24.354-24.354-182.32-182.32z"/></svg>
  </a>
  <h2 class="following-modal__title">
      Stream notifications
  </h2>
  <section class="following-modal__content">
    <ul>
      <li>
        <input type="radio"
          name="notificationStatus"
          (click)="selectNotificationStatus(true)"
          [checked]="notificationStatus">
        <span (click)="selectNotificationStatus(true)">Get Notifications of new notes on this stream.</span>
      </li>
      <li>
        <input type="radio"
          name="notificationStatus"
          (click)="selectNotificationStatus(false)"
          [checked]="!notificationStatus">
        <span (click)="selectNotificationStatus(false)">Turn off notifications for this stream.</span>
    </li>
    </ul>
  </section>
  <section class="following-modal__footer">
    <button
      (click)="updateStreamNotifications(); d('Cross click')"
      class="notd__button--v2 button--black">
      Save settings
    </button>
  </section>
</ng-template>


<ng-template #blockedUsersListModal let-c="close" let-d="dismiss">
  <a (click)="d('Cross click')" data-cy="close-modal" class="blocked-users-modal__close-btn" title="Close Modal">
      <svg enable-background="new 0 0 413.348 413.348" height="512" viewBox="0 0 413.348 413.348" width="512" xmlns="http://www.w3.org/2000/svg"><path d="m413.348 24.354-24.354-24.354-182.32 182.32-182.32-182.32-24.354 24.354 182.32 182.32-182.32 182.32 24.354 24.354 182.32-182.32 182.32 182.32 24.354-24.354-182.32-182.32z"/></svg>
  </a>
  <h2 class="blocked-users-modal__title">List of blocked users</h2>
  <section class="blocked-users-modal__content">
    <div
      *ngIf="!blockedUsersModalMessage.type && !blockedUsersModalMessage.message"
      class="blocked-users-modal__content__text">
      This is the list of users who are blocked from commenting on this stream
    </div>
    <ul
      *ngIf="!blockedUsersModalMessage.type && !blockedUsersModalMessage.message"
      class="blocked-users-modal__content__list">
      <li *ngFor="let u of blockedUsersList.blockedUsers; let i = index">
        <span class="blocked-users-modal__content__list__counter">{{i + 1}}.</span>
        <a
          class="blocked-users-modal__content__list__user"
          (click)="d('Cross click');"
          [routerLink]="['/user', u.user.id, 'profile']"
          [title]="'See ' + u.user.displayName  || u.user.userNameDisp + ' profile'">
            {{u.user.displayName  || u.user.userNameDisp}}
          </a>
        <div
          class="blocked-users-modal__content__list__actions">
          <button
            type="button"
            class="notd__button--v2" (click)="unblockUser(u)">Unblock</button>
        </div>
      </li>
    </ul>
    <div
      *ngIf="blockedUsersModalMessage.type && blockedUsersModalMessage.message"
      class="blocked-users-modal__content__message">
      <svg *ngIf="blockedUsersModalMessage.type === 'success'" style="enable-background:new 0 0 128 128;" version="1.1" viewBox="0 0 128 128" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><style type="text/css">
        .st5{fill:#31AF91;}
        .st1{fill:#FFFFFF;}
      </style><g><circle class="st5" cx="64" cy="64" r="64"/></g><g><path class="st1" d="M54.3,97.2L24.8,67.7c-0.4-0.4-0.4-1,0-1.4l8.5-8.5c0.4-0.4,1-0.4,1.4,0L55,78.1l38.2-38.2   c0.4-0.4,1-0.4,1.4,0l8.5,8.5c0.4,0.4,0.4,1,0,1.4L55.7,97.2C55.3,97.6,54.7,97.6,54.3,97.2z"/></g></svg>

      <svg *ngIf="blockedUsersModalMessage.type === 'error'" style="enable-background:new 0 0 128 128;" version="1.1" viewBox="0 0 128 128" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><style type="text/css">
        .st0{fill:#C93636;}
        .st1{fill:#FFFFFF;}
      </style><circle class="st0" cx="64" cy="64" r="64"/><path class="st1" d="M100.3,90.4L73.9,64l26.3-26.4c0.4-0.4,0.4-1,0-1.4l-8.5-8.5c-0.4-0.4-1-0.4-1.4,0L64,54.1L37.7,27.8  c-0.4-0.4-1-0.4-1.4,0l-8.5,8.5c-0.4,0.4-0.4,1,0,1.4L54,64L27.7,90.3c-0.4,0.4-0.4,1,0,1.4l8.5,8.5c0.4,0.4,1.1,0.4,1.4,0L64,73.9  l26.3,26.3c0.4,0.4,1.1,0.4,1.5,0.1l8.5-8.5C100.7,91.4,100.7,90.8,100.3,90.4z"/></svg>
      <p class="blocked-users-modal__content__message__text">
        {{blockedUsersModalMessage.message}}
      </p>
    </div>
    <div class="blocked-users-modal__content__buttons">
      <button
          type="button"
          class="notd__button--v2 button--black" (click)="d('Cross click');">Close</button>
    </div>
  </section>
</ng-template>


<ng-template #streamMemebersModal let-c="close" let-d="dismiss">
  <a (click)="d('Cross click')" data-cy="close-modal" class="stream-members-modal__close-btn" title="Close Modal">
      <svg enable-background="new 0 0 413.348 413.348" height="512" viewBox="0 0 413.348 413.348" width="512" xmlns="http://www.w3.org/2000/svg"><path d="m413.348 24.354-24.354-24.354-182.32 182.32-182.32-182.32-24.354 24.354 182.32 182.32-182.32 182.32 24.354 24.354 182.32-182.32 182.32 182.32 24.354-24.354-182.32-182.32z"/></svg>
  </a>
  <h2 class="stream-members-modal__title">List of Stream Community Members</h2>
  <section class="stream-members-modal__content">
    <section class="stream-members-modal__content__invite">
      <alert-message [alert]="alert"></alert-message>
      <form 
        novalidate
        (ngSubmit)="sendMemberInvitation()"
        [formGroup]="memberInviteForm"
        [ngClass]="{'form--invalid': memberInviteForm.invalid && memberInviteForm.touched}"
        class="stream-members-modal__content__invite__form">
        <label>User E-mail:</label>
        <div
          class="stream-members-modal__content__invite__form__input-wrapper">
          <input
            type="text"
            tabindex="10"
            class="notd__input"
            formControlName="email"
            [ngClass]="{'input--error': memberInviteForm.invalid && memberInviteForm.touched}"
            placeholder="Invitation E-mail"/>
            <span
              class="stream-members-modal__content__invite__form__input-wrapper__error"
              *ngIf="memberInviteForm.get('email').hasError('required') && memberInviteForm.get('email').touched">
                <svg enable-background="new 0 0 512 512" height="512" viewBox="0 0 512 512" width="512" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><linearGradient id="SVGID_1_" gradientUnits="userSpaceOnUse" x1="256" x2="256" y1="512" y2="0"><stop offset="0" stop-color="#fd3a84"/><stop offset="1" stop-color="#ffa68d"/></linearGradient><linearGradient id="lg1"><stop offset="0" stop-color="#ffc2cc"/><stop offset="1" stop-color="#fff2f4"/></linearGradient><linearGradient id="SVGID_2_" gradientUnits="userSpaceOnUse" x1="256" x2="256" xlink:href="#lg1" y1="301" y2="91"/><linearGradient id="SVGID_3_" gradientUnits="userSpaceOnUse" x1="256" x2="256" xlink:href="#lg1" y1="421" y2="331"/><g><g><path d="m355.826 512h-199.651c-3.979 0-7.794-1.58-10.606-4.394l-141.175-141.174c-2.814-2.813-4.394-6.628-4.394-10.606v-199.652c0-3.978 1.58-7.793 4.394-10.606l141.174-141.174c2.813-2.814 6.628-4.394 10.607-4.394h199.651c3.979 0 7.794 1.581 10.606 4.394l141.174 141.174c2.813 2.813 4.394 6.628 4.394 10.606v199.651c0 3.978-1.58 7.793-4.394 10.606l-141.173 141.175c-2.813 2.813-6.628 4.394-10.607 4.394z" fill="url(#SVGID_1_)"/></g><g id="Error"><g><path d="m256 301c-24.813 0-45-20.187-45-45v-120c0-24.813 20.187-45 45-45s45 20.187 45 45v120c0 24.813-20.187 45-45 45z" fill="url(#SVGID_2_)"/></g><g><path d="m256 421c-24.813 0-45-20.187-45-45s20.187-45 45-45 45 20.187 45 45-20.187 45-45 45z" fill="url(#SVGID_3_)"/></g></g></g></svg>
                Please enter user e-mail.</span>
            <span
              class="stream-members-modal__content__invite__form__input-wrapper__error"
              *ngIf="memberInviteForm.get('email').hasError('email') && memberInviteForm.get('email').touched">
              <svg enable-background="new 0 0 512 512" height="512" viewBox="0 0 512 512" width="512" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><linearGradient id="SVGID_1_" gradientUnits="userSpaceOnUse" x1="256" x2="256" y1="512" y2="0"><stop offset="0" stop-color="#fd3a84"/><stop offset="1" stop-color="#ffa68d"/></linearGradient><linearGradient id="lg1"><stop offset="0" stop-color="#ffc2cc"/><stop offset="1" stop-color="#fff2f4"/></linearGradient><linearGradient id="SVGID_2_" gradientUnits="userSpaceOnUse" x1="256" x2="256" xlink:href="#lg1" y1="301" y2="91"/><linearGradient id="SVGID_3_" gradientUnits="userSpaceOnUse" x1="256" x2="256" xlink:href="#lg1" y1="421" y2="331"/><g><g><path d="m355.826 512h-199.651c-3.979 0-7.794-1.58-10.606-4.394l-141.175-141.174c-2.814-2.813-4.394-6.628-4.394-10.606v-199.652c0-3.978 1.58-7.793 4.394-10.606l141.174-141.174c2.813-2.814 6.628-4.394 10.607-4.394h199.651c3.979 0 7.794 1.581 10.606 4.394l141.174 141.174c2.813 2.813 4.394 6.628 4.394 10.606v199.651c0 3.978-1.58 7.793-4.394 10.606l-141.173 141.175c-2.813 2.813-6.628 4.394-10.607 4.394z" fill="url(#SVGID_1_)"/></g><g id="Error"><g><path d="m256 301c-24.813 0-45-20.187-45-45v-120c0-24.813 20.187-45 45-45s45 20.187 45 45v120c0 24.813-20.187 45-45 45z" fill="url(#SVGID_2_)"/></g><g><path d="m256 421c-24.813 0-45-20.187-45-45s20.187-45 45-45 45 20.187 45 45-20.187 45-45 45z" fill="url(#SVGID_3_)"/></g></g></g></svg>
                This e-mail is incorrect.</span>
        </div>
        <button
          type="submit"
          [ngClass]="{'button-spinner' : sendInvitationLoading}"
          class="notd__button--v2 button--black">Send Invitation</button>
      </form>
      <p class="stream-members-modal__content__invite__description">
        You can add new users to your community by sending them invitaion using their e-mail address.
      </p>
    </section>
    <section class="stream-members-modal__content__loading" *ngIf="streamMemebers.loading && this.streamMemebers.list === null">
      <span class="stream-members-modal__content__loading__spinner"></span>
      <p class="stream-members-modal__content__loading__label">Loading stream members...</p>
    </section>
    <section
        *ngIf="!streamMemebers.loading && this.streamMemebers.list.length === 0"
        class="stream-members-modal__content__info-message">
        <svg data-name="Layer 1" id="Layer_1" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><defs><style>.cls-1{fill:#7dccfc;}</style></defs><path class="cls-1" d="M16,1A15,15,0,1,0,31,16,15,15,0,0,0,16,1Zm2,22a2,2,0,0,1-4,0V16a2,2,0,0,1,4,0ZM16,12.19A2.19,2.19,0,1,1,18.19,10,2.19,2.19,0,0,1,16,12.19Z"/></svg>
        <p>
            There are no members on your list yet.
        </p>
    </section>
    <ul
      *ngIf="streamMemebers && streamMemebers.list"
      class="stream-members-modal__content__list">
      <li *ngFor="let member of streamMemebers.list; let i = index">
        <span class="stream-members-modal__content__list__counter">{{i + 1}}.</span>
        <a
          class="stream-members-modal__content__list__user"
          [routerLink]="['/user', member.user.id, 'profile']"
          target="_blank"
          [title]="'See ' + member.user.displayName  || member.user.userNameDisp + ' profile'">
            {{member.user.displayName  || member.user.userNameDisp}}
          </a>
        <div
          class="stream-members-modal__content__list__actions">
          <span
            class="stream-members-modal__content__list__actions__status">{{member.inviteAccepted ? 'invite accepted' : 'invite pending'}}</span>
          <button
            type="button"
            class="notd__button--v2 button--green" (click)="removeUser(member)">Remove</button>
        </div>
      </li>
    </ul>
    <div
      *ngIf="blockedUsersModalMessage.type && blockedUsersModalMessage.message"
      class="stream-members-modal__content__message">
      <svg *ngIf="blockedUsersModalMessage.type === 'success'" style="enable-background:new 0 0 128 128;" version="1.1" viewBox="0 0 128 128" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><style type="text/css">
        .st5{fill:#31AF91;}
        .st1{fill:#FFFFFF;}
      </style><g><circle class="st5" cx="64" cy="64" r="64"/></g><g><path class="st1" d="M54.3,97.2L24.8,67.7c-0.4-0.4-0.4-1,0-1.4l8.5-8.5c0.4-0.4,1-0.4,1.4,0L55,78.1l38.2-38.2   c0.4-0.4,1-0.4,1.4,0l8.5,8.5c0.4,0.4,0.4,1,0,1.4L55.7,97.2C55.3,97.6,54.7,97.6,54.3,97.2z"/></g></svg>

      <svg *ngIf="blockedUsersModalMessage.type === 'error'" style="enable-background:new 0 0 128 128;" version="1.1" viewBox="0 0 128 128" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><style type="text/css">
        .st0{fill:#C93636;}
        .st1{fill:#FFFFFF;}
      </style><circle class="st0" cx="64" cy="64" r="64"/><path class="st1" d="M100.3,90.4L73.9,64l26.3-26.4c0.4-0.4,0.4-1,0-1.4l-8.5-8.5c-0.4-0.4-1-0.4-1.4,0L64,54.1L37.7,27.8  c-0.4-0.4-1-0.4-1.4,0l-8.5,8.5c-0.4,0.4-0.4,1,0,1.4L54,64L27.7,90.3c-0.4,0.4-0.4,1,0,1.4l8.5,8.5c0.4,0.4,1.1,0.4,1.4,0L64,73.9  l26.3,26.3c0.4,0.4,1.1,0.4,1.5,0.1l8.5-8.5C100.7,91.4,100.7,90.8,100.3,90.4z"/></svg>
      <p class="stream-members-modal__content__message__text">
        {{blockedUsersModalMessage.message}}
      </p>
    </div>
    <div class="stream-members-modal__content__buttons">
      <button
          type="button"
          class="notd__button--v2 button--black" (click)="d('Cross click');">Close</button>
    </div>
  </section>
</ng-template>

<stream-creator-modal
  [stream]="stream"
  (closeStreamModalEmitter)="closeStreamCreatorModal()"
  (savedStreamEmitter)="streamSavedUpdate($event)">
</stream-creator-modal>

<stream-stats-modal
  *ngIf="isEditable && !editingStream"
  [stream]="stream">
</stream-stats-modal>

<notd-partners-modal
  #notdPartnersModalCommunity
  [splitButtons]="true"
  [buttonLabel]="'Sign-up or Login'"></notd-partners-modal>
